import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

// Administrator-only, and that is also what hides the sidebar entry: SidebarGroup resolves each item's
// permissions from the route it points at, so the `permissions` meta below is the only gate needed.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/work-schedules'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'work_schedules_wrapper',
          meta: {
            permissions: ['administrator'],
          },
          redirect: to => {
            return { name: 'work_schedules_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'work_schedules_list',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
      ],
    },
  ],
};
